import { Component, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Observable, of } from 'rxjs';
import { catchError, debounceTime, map, startWith, switchMap } from 'rxjs/operators';
import { IAgent } from 'src/app/interfaces/agent/iagent';
import { ILower } from 'src/app/interfaces/commission/Ilower';
import { AgentService } from 'src/app/services/agent.service';
import { CommissionService } from 'src/app/services/commission.service';
import { DictionaryService } from 'src/app/services/dictionary.service';
import { ServiceService } from 'src/app/services/service.service';

@Component({
  selector: 'app-edit-tariff',
  templateUrl: './edit-tariff.component.html',
  styleUrls: ['./edit-tariff.component.css']
})
export class EditTariffComponent implements OnInit {

  isCompleted: boolean = false;
  lowers: ILower[] = [];
  tariffForm: FormGroup;
  
  tariffInfo: any;
  data: any[];
  tariffId: number;
  incorrectServiceList: any[]; 
  previousIndexTarriff: number = -1;
  agent: any;
  categories: any;
  panelOpenState = false;
  previousCategory: any = null;
  currentCategoryIndex: number = 0;

  constructor(private fb: FormBuilder,
  public snackBar: MatSnackBar,
  private translate: TranslateService,
  private commissionSrv: CommissionService,
  public dialog: MatDialog,
  private route: ActivatedRoute,
  private serviceSrv: ServiceService,
  private agentSrv: AgentService) { }

  ngOnInit(): void {
      this.load();
  }

  load() {
    this.route.paramMap.pipe(
      switchMap(params => params.getAll('id'))
    )
      .subscribe(data => this.tariffId = +data);
    this.getTariff(this.tariffId);
  }

  get tariffValues() {
    return (<FormArray>this.tariffForm.get('tariffValues')).controls;
  }

  getAgent(){
    this.agentSrv.agent().subscribe((data: any) =>{
      this.agent = data;
      this.getCategory();
    },
      error => {
        if (error.status === 409) {
          let message = this.translate.instant('an-error-occurred-while-processing');
          this.openSnackBar(message, 'x');
        }
        else
          if (error.status === 400) {
            let message = this.translate.instant('an-error-occurred-while-processing');
            this.openSnackBar(message, 'x');
          }
          else
            if (error.status === 500) {
              let message = this.translate.instant('service-is-temporarily-unavailable');
              this.openSnackBar(message, 'x');
            }
            else {
              let message = this.translate.instant('an-error-occurred-while-processing');
              this.openSnackBar(message, 'x');
            }
      }
    )
  }

  getCategory(){
    this.serviceSrv.categories(this.agent.regionId).subscribe((data: any) =>{
      for (let index = 0; index < data.length; index++) {
        data[index]["panelOpenState"] = false;
      }
      this.categories = data;
    },
      error => {
        this.isCompleted = true; 
        if (error.status === 409) {
          let message = this.translate.instant('an-error-occurred-while-processing');
          this.openSnackBar(message, 'x');
        }
        else
          if (error.status === 400) {
            let message = this.translate.instant('an-error-occurred-while-processing');
            this.openSnackBar(message, 'x');
          }
          else
            if (error.status === 500) {
              let message = this.translate.instant('service-is-temporarily-unavailable');
              this.openSnackBar(message, 'x');
            }
            else {
              let message = this.translate.instant('an-error-occurred-while-processing');
              this.openSnackBar(message, 'x');
            }
      }
    ).add(() => { this.isCompleted = true });
  }

  getTariff(tariffId) {
    this.commissionSrv.getAgentCreatedTariff(tariffId).subscribe(
      (data: any) => { 
        this.tariffInfo = data;
        this.getValuesByTariff(this.tariffInfo.id);
        this.getAgent();
      },
      error => {
        this.isCompleted = true; 
        if (error.status === 409) {
          let message = this.translate.instant('an-error-occurred-while-processing');
          this.openSnackBar(message, 'x');
        }
        else
          if (error.status === 400) {
            let message = this.translate.instant('an-error-occurred-while-processing');
            this.openSnackBar(message, 'x');
          }
          else
            if (error.status === 500) {
              let message = this.translate.instant('service-is-temporarily-unavailable');
              this.openSnackBar(message, 'x');
            }
            else {
              let message = this.translate.instant('an-error-occurred-while-processing');
              this.openSnackBar(message, 'x');
            }
      }
    )
  }

  getValuesByTariff(tariffId) {
    this.commissionSrv.getServicesLowers(tariffId).subscribe(
      (data: any) => { 
        this.lowers = data;

        this.tariffForm = this.fb.group({
            id: new FormControl(this.tariffInfo.id, Validators.required),
            name: new FormControl(this.tariffInfo.name, Validators.required),
            tariffValues: this.fb.array(this.getTariffValues())
        });
      },
      error => {
        if (error.status === 409) {
          let message = this.translate.instant('an-error-occurred-while-processing');
          this.openSnackBar(message, 'x');
        }
        else
          if (error.status === 400) {
            let message = this.translate.instant('an-error-occurred-while-processing');
            this.openSnackBar(message, 'x');
          }
          else
            if (error.status === 500) {
              let message = this.translate.instant('service-is-temporarily-unavailable');
              this.openSnackBar(message, 'x');
            }
            else {
              let message = this.translate.instant('an-error-occurred-while-processing');
              this.openSnackBar(message, 'x');
            }
      }
    ).add(() => { this.isCompleted = true })
  }

  // convenience getter for easy access to form fields
  get f() { return this.tariffForm.controls; }
  public hasError = (controlName: string, errorName: string) => {
    return this.tariffForm.controls[controlName].hasError(errorName);
  }

  public update = (formContent) => {
    if (this.tariffForm.valid) {
      this.execute(formContent);
    }
  }

  private execute = (data) => {
    this.incorrectServiceList = null;

    let json: any = {
        name: data.name,
        tariffValues: data.tariffValues
    }

    this.commissionSrv.updateTariffValues(json, this.tariffInfo.id)
      .subscribe(
        data => {
          let message = this.translate.instant('tariff-success-updated');
          this.openSnackBar(message, 'x');    
          window.location.href = "/settings/tariffs";
        },
        error => {
          if (error.status === 409) {
            let message = this.translate.instant('an-error-occurred-while-processing');
            this.openSnackBar(message, 'x');
          }
          else
            if (error.status === 400) {
              let message = this.translate.instant(error.error.message);
              this.openSnackBar(message, 'x');
              this.incorrectServiceList = error.error.incorrectServiceList;
            }
            else
              if (error.status === 500) {
                let message = this.translate.instant('service-is-temporarily-unavailable');
                this.openSnackBar(message, 'x');
              }
              else {
                let message = this.translate.instant('an-error-occurred-while-processing');
                this.openSnackBar(message, 'x');
              }
        }
      );
  }

  openSnackBar(message: string, action: string) {
    this.snackBar.open(message, action, {
      duration: 5000,
    });
  }

  setEditableCommissions(index){
    if(this.previousIndexTarriff == -1 || (<FormArray>this.tariffForm.get('tariffValues')).controls[this.previousIndexTarriff]?.valid){
      (<FormArray>this.tariffForm.get('tariffValues')).controls[this.previousIndexTarriff]?.get("isEdit").setValue(false);
      (<FormArray>this.tariffForm.get('tariffValues')).controls[index].get("isEdit").setValue(true);
      this.previousIndexTarriff = index;      
    }
  }

  setOpenOrCloseCategory(category){
    if(this.categories.filter(f => f.id == this.currentCategoryIndex)[0]){
      this.categories.filter(f => f.id == this.currentCategoryIndex)[0]["panelOpenState"] = false;
    }
    this.categories.filter(f => f.id == category.id)[0]["panelOpenState"] = true;
    this.currentCategoryIndex = category.id;
  }

  saveCommissions(index){
    if((<FormArray>this.tariffForm.get('tariffValues')).controls[index].valid){
      (<FormArray>this.tariffForm.get('tariffValues')).controls[index].get("isEdit").setValue(false);
    }
  }

  getTariffValues() {
    return this.lowers.map(lower => this.fb.group({
      serviceId: new FormControl(lower.serviceId, Validators.required),
      serviceName: new FormControl(lower.serviceName, Validators.required),
      itoPercent: new FormControl(lower.itoPercent / 100, Validators.required),
      itoFix: new FormControl(lower.itoFix / 100, Validators.required),
      lowerPercent: new FormControl(lower.lowerPercent / 100, Validators.required),
      lowerFix: new FormControl(lower.lowerFix / 100, Validators.required),
      isEdit: new FormControl(false, Validators.required),
      categoryName: new FormControl(lower.categoryName, Validators.required)
    }));
  }
}
